import axios from './axios'


export function login(data){
    return axios.post(`sys/login`,data)
   
}

// 查询售卖亭
export function listPage(data){
    return axios.post(`kiosk/listPage`,data)
}

// 新增售卖亭
export function itemAdd(data){
    return axios.post(`kiosk/save`,data)
}

// 删除售卖亭
export function itemDelete(data){
    return axios.post(`kiosk/delete`,data)
}

// 修改售卖亭
export function itemUpdate(data){
    return axios.post(`kiosk/update`,data)
}




